import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/sign-up-login-screen/components/AuthScreen.tsx");
